import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import { SpinnerService } from "../services/spinner.service";
import { MessageService } from "primeng/api";
import { ConfirmationService, SelectItem } from "primeng/primeng";
import { User } from "../models/User";
import { AuthService } from "../services/auth.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-equipment-variable",
  templateUrl: "./equipment-variable.component.html",
  styleUrls: ["./equipment-variable.component.css"]
})
export class EquipmentVariableComponent implements OnInit {
  @Input() variable: Object;
  @Output() onDeleteVariable: EventEmitter<string>;
  @Output() onSaveVariable: EventEmitter<Object>;
  @Output() onCancel: EventEmitter<boolean>;
  eqvarinout: string[] = ["In", "Out"];
  eqvartypes: string[] = ["Bool", "Int", "Decimal", "String"];
  eqVarsInOut: SelectItem[];
  eqVarsTypes: SelectItem[];

  user: User;
  displayDialog: boolean = false;

  constructor(
    private spinnerService: SpinnerService,
    private messageService: MessageService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {
    this.onCancel = new EventEmitter();
    this.onSaveVariable = new EventEmitter();
    this.onDeleteVariable = new EventEmitter();
  }

  ngOnInit() {
    this.authService.getLogged().subscribe(
      user => {
        this.user = user;
      }
    );
    this.eqVarsInOut = this.eqvarinout.map(x => { return { label: x, value: x } });
    this.eqVarsTypes = this.eqvartypes.map(x => { return { label: x, value: x } });
    if (this.eqvartypes.length > 0) {
      if (!this.variable["type"]) this.variable["type"] = this.eqvartypes[0];
    }
    if (this.eqvarinout.length > 0) {
      if (!this.variable["inout"]) this.variable["inout"] = this.eqvarinout[0];
    }
  }

  save() {
    //update
    console.log("Updating ", this.variable);
    if (this.formDataValid(this.variable)) {
      this.onSaveVariable.emit(this.variable);
    }
  }

  //this.variable = null;

  newVariable() {
    if (!this.variable["id"]) {
      return true;
    } else {
      return false;
    }
  }

  formDataValid(variable: object) {
    let dataValid = true;
    let errorMessages: string[] = [];
    if (!variable["name"]) errorMessages.push(this.translate.instant('Error_Required_Name'));
    if (variable["type"] == "String") {
      if (!variable["strlen"]) errorMessages.push(this.translate.instant('Error_Required_Length'));
      else {
        if (!(Number(variable["strlen"]) > 0 && Number(variable["strlen"]) < 100)) errorMessages.push(this.translate.instant('Error_String_Length'));
      }
    }

    if (errorMessages.length > 0) {
      dataValid = false;
      this.messageService.add({
        severity: "error",
        summary: this.translate.instant('Error_Formulary'),
        detail: errorMessages.join("<p></p>")
      });
    }
    return dataValid;
  }

  confirmDeleteVariable() {
    this.confirmationService.confirm({
      message: this.translate.instant('Warning_Delete_EquipmentVar', {
        value: this.variable["name"]
      }),
      accept: () => {
        this.delete();
      }
    });
  }

  delete() {
    if (this.variable["id"]) {
      this.onDeleteVariable.emit(this.variable["id"]);
    }
  }

  cancel() {
    this.onCancel.emit(true);
  }

  hasRoleEdit() {
    if (this.user) {
      if (this.user.roles) return (
        this.user.roles.includes("CATEGORY.EDIT") ||
        this.user.roles.includes("COMPANY_ADMIN") ||
        this.user.roles.includes("CATEGORY.CREATE")
      );
    }
  }
  hasRoleDelete() {
    if (this.user) {
      if (this.user.roles) return (
        this.user.roles.includes("CATEGORY.DELETE") || this.user.roles.includes("COMPANY_ADMIN"));
    }
  }
}
